import { CalendarClock, Loader2 } from 'lucide-react'
import * as m from '~/paraglide/messages'
import { Alert, AlertDescription, AlertTitle } from '~/shared/ui/alert'
import { Button } from '~/shared/ui/button'
import type { PendingChange } from '../api/stripe-api'
import { billingPeriodLabel, planName } from '../plans'

interface PendingChangeAlertProps {
  pendingChange: PendingChange
  onRevert: () => void
  isReverting: boolean
}

export function PendingChangeAlert({
  pendingChange,
  onRevert,
  isReverting,
}: PendingChangeAlertProps) {
  const date = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium' }).format(
    new Date(pendingChange.effectiveAt),
  )

  return (
    <Alert>
      <CalendarClock className="h-4 w-4" />
      <AlertTitle>{m.scheduledChangeTitle()}</AlertTitle>
      <AlertDescription className="flex flex-wrap items-center justify-between gap-3">
        <span>
          {pendingChange.targetTier === 'free'
            ? m.scheduledCancellationDescription({ date })
            : m.scheduledChangeDescription({
                // Without the period a same-tier switch would read "changes to Premium"
                // to someone already on Premium.
                tier: pendingChange.targetBillingPeriod
                  ? `${planName(pendingChange.targetTier)} · ${billingPeriodLabel(pendingChange.targetBillingPeriod)}`
                  : planName(pendingChange.targetTier),
                date,
              })}
        </span>
        <Button variant="outline" size="sm" onClick={onRevert} disabled={isReverting}>
          {isReverting ? <Loader2 className="h-4 w-4 animate-spin" /> : m.revertScheduledChange()}
        </Button>
      </AlertDescription>
    </Alert>
  )
}
